export enum StorePaymentConfigurationType {
  CHECKOUT = "CHECKOUT",
  WHENTHEN = "WHENTHEN",
  WORLDPAY = "WORLDPAY",
}

export class StorePaymentConfiguration {
  type: StorePaymentConfigurationType | null;

  publicKey: string | null;
  secretKey: string | null;
  useSandbox: boolean | null;

  flowId: string | null;
  merchantId: string | null;

  merchantEntity: string | null;

  constructor(
    type: StorePaymentConfigurationType | null,
    publicKey: string | null,
    secretKey: string | null,
    useSandbox: boolean | null,
    flowId: string | null,
    merchantId: string | null,
    merchantEntity: string | null
  ) {
    this.type = type;

    this.publicKey = publicKey;
    this.secretKey = secretKey;
    this.useSandbox = useSandbox;

    this.flowId = flowId;
    this.merchantId = merchantId;

    this.merchantEntity = merchantEntity;
  }
}
